import { useLocation } from "react-router";

import { usePageModalLocationState } from "@/modules/page-modal";

export const useAppMainRoutesLocation = () => {
  const location = useLocation();
  const { backgroundLocation } = usePageModalLocationState();

  // controlledLocation is used to override default app location
  // for the pages displayed in background. For them, we want to keep
  // the previous location and have 2 pages location at the same time.
  const controlledLocation = backgroundLocation
    ? {
        ...backgroundLocation,
        state: { isBackgroundLocation: true, ...backgroundLocation.state },
      }
    : location;

  return controlledLocation;
};
